module.exports = __webpack_public_path__ + "static/media/profile-icon.ec75044f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile-icon.png
// module id = 92
// module chunks = 0